
/**
 * Pagetop
 * @constructor
 */
class Pagetop {
  constructor() {}
  /**
   * Pagetop
   */
  init() {
    var topBtn = $('#pagetop');
    topBtn.hide();
    $(window).scroll(function () {
      if ($(this).scrollTop() > 200) {
        topBtn.fadeIn();
      } else {
        topBtn.fadeOut();
      }
    });
    topBtn.click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 500);
      return false;
    });
  }
};

export default Pagetop;
